import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=4421d0c4&"
import script from "./projectDetail.vue?vue&type=script&lang=js&"
export * from "./projectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4421d0c4')) {
      api.createRecord('4421d0c4', component.options)
    } else {
      api.reload('4421d0c4', component.options)
    }
    module.hot.accept("./projectDetail.vue?vue&type=template&id=4421d0c4&", function () {
      api.rerender('4421d0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProjectManage/components/project/projectDetail.vue"
export default component.exports